function s(t) {
  return t === "0rem" ? "0rem" : `calc(${t} * var(--mantine-scale))`;
}
function f(t, { shouldScale: i = !1 } = {}) {
  function c(r) {
    if (r === 0 || r === "0")
      return `0${t}`;
    if (typeof r == "number") {
      const e = `${r / 16}${t}`;
      return i ? s(e) : e;
    }
    if (typeof r == "string") {
      if (r === "" || r.startsWith("calc(") || r.startsWith("clamp(") || r.includes("rgba("))
        return r;
      if (r.includes(","))
        return r.split(",").map((n) => c(n)).join(",");
      if (r.includes(" "))
        return r.split(" ").map((n) => c(n)).join(" ");
      if (r.includes(t))
        return i ? s(r) : r;
      const e = r.replace("px", "");
      if (!Number.isNaN(Number(e))) {
        const n = `${Number(e) / 16}${t}`;
        return i ? s(n) : n;
      }
    }
    return r;
  }
  return c;
}
const m = f("rem", { shouldScale: !0 }), o = f("em");
export {
  o as e,
  m as r
};
